import React from 'react';

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { TextInput, DateInput } from 'components/input';

import { SORT_DESC } from "reducers/resource/list/queryReducer";

export const ProductOrderFilter = (props) => (
  <FilterForm name="order_search" {...props}>
    <DateInput label="From" source="order_from"/>
    <DateInput label="To" source="order_to"/>
    <TextInput label="Owner Mobile" source="owner_mobile_number"/>
    <TextInput label="Shop ID" source="shop_id"/>
    <TextInput label="APA Order ID" source="apa_order_id"/>
  </FilterForm>
);


const listActionOptions = {
  hasExport: false
};

export const ProductOrderList = (props) => (
  <List {...listActionOptions} filters={<ProductOrderFilter/>}
        sort={{ field: 'order_time', order: SORT_DESC}} {...props}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="shop_id" label="Shop ID"/>
      <TextField source="target_shop_id" label="Target Shop ID"/>
      <TextField source="target_shop_name" label="Target Shop Name"/>
      <TextField source="owner_mobile_number" label="Owner Mobile"/>
      <TextField source="quantity" label="Quantity"/>
      <TextField source="product" label="Product"/>
      <TextField source="amount" label="Amount"/>
      <TextField source="payment_type" label="Payment Type"/>
      <TextField source="payment_status" label="Payment Status"/>
      <TextField source="expiry_before" label="Expiry Before"/>
      <TextField source="expiry_after" label="Expiry After"/>
      <TextField source="order_id" label="Ocha Order ID"/>
      <TextField source="id" label="Order Item ID"/>
      <TextField source="apa_order_id" label="APA Order ID"/>
      <TextField source="order_time" label="Order Time"/>
      <TextField source="reason" label="Reason"/>
      <TextField source="comment" label="Comment"/>
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./src/routes/product/ProductOrderList.js